<x-shop-dialog
  i18n-heading="@@Error.OrderRecreate.Heading"
  heading="Sorry,"
  i18n-subheading="@@Error.OrderRecreate.OrderCreationProblem.Subheading"
  subheading="We had some trouble recreating your order. Contact us for assistance or continue shopping."
  [canClose]="true"
  (closeDialog)="closeDialog()"
>
  <x-shop-dialog-actions>
    <button xNeedHelp mat-stroked-button color="primary" xAction i18n="@@CallToAction.NeedHelp">
      Need Help?
    </button>
    <button
      mat-flat-button
      color="primary"
      xAction
      xGoHomeLink
      i18n="@@CallToAction.BackToShopping"
    >
      Back to shopping
    </button>
  </x-shop-dialog-actions>
</x-shop-dialog>
